module.exports = __webpack_public_path__ + "static/Muxg4oO-67362a175229b51521ad470dd72a3e2a.jpg";